var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component island-header"},[_c('IslandTitle',[_vm._v(_vm._s(_vm.title))]),(_vm.annotation)?_c('div',{staticClass:"title-annotation"},[_vm._v(_vm._s(_vm.annotation))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }